export const data = {
  raffi: {
    name: "Raffi Hotter",
    image: "raffi.jpeg",
    twitter: "raffi_hotter",
    github: "rhotter",
    curius: "raffi-hotter",
    description:
      "Raffi is on a quest to hack the brain. He's a senior at McGill studying Math, Computer Science and Physics, and he is building a  $1000 portable brain scanner. Previously, he interned at Google X on a neuroscience project and represented Canada at ISEF, winning 2nd place in Physics. He's obsessed with hot chocolate.",
  },
  marley: {
    name: "Marley Xiong",
    image: "marley.jpeg",
    website: "marleyx.com",
    twitter: "_marleyx",
    curius: "marley-xiong",
    github: "io0",
    description:
      "Marley smarley barley tarley darley. Marley built a brain-controlled wheelchair, worked on a neuroscience project at Google X, represented Canada at the International Biology Olympiad, built a treehouse in the Amazon jungle, and unravelled the secrets to the human brain. Just kidding - the last two are not true (yet).",
  },
  chris: {
    name: "Chris Axon",
    image: "chris.jpeg",
    website: "",
    github: "caxon",
    twitter: "caxon_",
    curius: "chris-axon",
    description:
      "Chris runs very fast and is interested in too many things. He likes learning and building and managing large amounts of money. He is currently engineering at Copysmith AI and wants to live somewhere other than Boston.",
  },

  amanda: {
    name: "Amanda Ngo",
    image: "amanda.png",
    website: "www.amandango.me/",
    twitter: "manda_ngo",
    github: "",
    description:
      "Amanda is building tools to automate complex reasoning. She studied Econ at Wharton, and is a Kiwi living in the United States. she loves co-opting friends into social experiments, understanding how brains work, and figuring out what it means to live a good life.",
  },
  athena: {
    name: "Athena Leong",
    image: "athena.jpeg",
    website: "athenaleong.tech/",
    twitter: "athleong",
    github: "athenaleong",
    curius: "athena-leong",
    description:
      "Athena is a CS student at UC Berkeley who loves tinkering with crazy ideas. She grew up in Singapore where she developed a passion for air humidifiers and monopolizing pineapples. She is a social butterfly and brings too much chaos and laughter.",
  },
  azlen: {
    name: "Azlen Elza",
    image: "azlen.png",
    website: "azlen.me/",
    github: "azlen",
    twitter: "azlenelza",
    description:
      "Azlen is a programmer and designer. Many of his projects lie in questioning or inventing the future of human-computer interaction; whether that is designing new ways to learn with technology, or experimenting with the limits of AI and Neural Networks. He works in a research lab at Emily Carr University where he teaches AI to create images, write novels, and compose music.",
  },
  bonnie: {
    name: "Bonnie Li",
    image: "bonnie.png",
    website: "bonniesjli.github.io/",
    github: "bonniesjli",
    twitter: "bonniesjli",
    curius: "bonnie-li",
    description:
      "Bonnie is a teen AI research prodigy. She is working towards a more generalized notion of artificial intelligence. She is studying Math and CS at McGill and working on reinforcement learning with Joelle Pineau. She is interested in reinforcement learning, meta learning, and latent space modeling. In the past she worked on reinforcement learning at Mila in Yoshua Bengio's group, then imitation learning at Vector Institute in Jimmy Ba's group.",
  },
  david: {
    name: "David Holz",
    image: "david.jpeg",
    twitter: "DavidSHolz",
    website: "davidsholz.com",
    description:
      "David is the cofounder and CTO of Leap Motion. His previous lives were spent at NASA, Max Planck, and doing a PhD at UNC Chapel Hill. He will work on self-replicating robots to send people to space.",
  },
  dhruvik: {
    name: "Dhruvik Parikh",
    image: "dhruvik.jpeg",
    twitter: "dhruvik_parikh7",
    website: "dhruvikparikh.com",
    github: "dhruvik7",
    curius: "dhruvik sanjay-parikh",
    description:
      "Dhruvik is a junior studying computer science at Stanford and a software engineer at Kalshi. On campus, Dhruvik is involved with research and sustainability initiatives, including organizing the Stanford Cleantech Challenge. Previously, he has worked on front-end at Microsoft, embedded systems at Voya Sol, and conducted energy research that placed him on the 2019 Forbes 30 Under 30 list. In his spare time, Dhruvik enjoys cooking and solving Rubik's cubes.",
  },
  dmitri: {
    name: "Dmitri Brereton",
    image: "dmitri.jpeg",
    twitter: "dkb868",
    github: "dkb868",
    curius: "dmitri-brereton",
    description:
      "Dmitri is possibly the most ambitious engineer from his home island of Trinidad. He studied at UCLA, where he built dating apps that are better than Tinder, and he more recently built a poker website and started work at Gem. He wants to find and search through all the blogs of the Internet.",
  },
  emma: {
    name: "Emma Qian",
    image: "emma.png",
    github: "",
    description:
      "Emma is a freshly minted DeepMind alumnus with a newfound interest in startups. She is studying CS at Caltech and played hockey at Cambridge. She worked at Facebook, Facebook AI Research, Jump Trading, and DeepMind. She has a quite 'sophisticated' taste in modern music.",
  },
  ethan: {
    name: "Ethan Perez",
    image: "ethan.jpeg",
    github: "ethanjperez",
    website: "ethanperez.net/",
    description:
      "Ethan is a PhD student in Natural Language Processing at New York University. He is advised by Kyunghyun Cho and Douwe Kiela and funded by NSF and Open Philanthropy. His research focuses on developing learning algorithms that have the long-term potential to answer questions that people cannot. Previously, he worked with Aaron Courville and Hugo Larochelle at the Montreal Institute for Learning Algorithms, and he has also spent time at Facebook AI Research and Google.",
  },
  felipe: {
    name: "Felipe Calero Forero",
    image: "felipe.jpeg",
    twitter: "CaleroForero",
    curius: "felipe-calero forero",
    description:
      "Felipe led Effective Altruism at Stanford and brought it to New Mexico. Felipe is a 3rd year CS student at Stanford, where he helped build and run Stanford Effective Altruism and Stanford Existential Risks Initiative. He has previously worked on AI governance and biosecurity projects at the Open Philanthropy Project, and synthetic biology research at the Qi lab.",
  },
  geffen: {
    name: "Geffen Avraham",
    image: "geffen.png",
    twitter: "geffenavraham",
    github: "",
    website: "",
    description:
      "Geffen sent satellites into space and cooks great chicken. Geffen designed a CubeSat mission to one of Saturn’s moons, leading him to become the only high-schooler invited to the International Astronautical Congress (IAC) hosted in China. At 16, he left school to pursue his passion for building satellites at a local laboratory. He’s also currently working on a program to tell where (on Earth) a satellite picture was taken.",
  },
  harshu: {
    name: "Harshu Musunuri",
    image: "harshu.jpeg",
    twitter: "HarshuMusunuri",
    curius: "harshu-musunuri",
    description:
      "Harshu is a Stanford Chemist who works on projects to save lives. She has done research with NASA’s JPL, built a seizure detection app for epileptic patients and is now working on a project with the potential to save thousands of lives. She’s also a hacker at heart: when she lacked the formal lab tools to braze at high temperature, she used the exhaust vent of a ceramic kiln.",
  },
  jonathan: {
    name: "Jonathan Xu",
    image: "jonathan.jpeg",
    twitter: "jonxuxu",
    website: "jonathanxu.com",
    github: "JonathanXu1",
    curius: "jonathan-xu",
    description:
      "Jonathan is a software engineering student from Waterloo(?) who has been to over 40 hackathons, building cross-discipline projects that are a mix of crazy, useful, or funny. He is currently in Taiwan, exploring ways to digitize human experiences through AR in video. Recently, Jonathan's been learning Chinese, writing, and breaking his fingertips on the guitar.",
    backgroundColor: "#00f",
  },
  kesava: {
    name: "Kesava Kirupa Dinakaran",
    image: "kesava.jpeg",
    twitter: "kesava_kirupa",
    description:
      "Kesava is a co-founder of DigitalBrain and was part of the YC Summer 2020 batch. He is an immigrant fom India and was the youngest person to cycle across the Silk Road. He was also the 2x Rubik's cube world record holder.",
  },
  liam: {
    name: "Liam Hinzman",
    image: "liam.jpeg",
    twitter: "LiamHinzman",
    website: "liamhinzman.com",
    github: "LiamHz",
    curius: "liam-hinzman",
    description:
      "Liam is an eighteen-year-old who does machine learning, full-stack, and computer graphics. He recently dropped out of school and worked at Reduct Video, and is currently building collective machine intelligence at Numerai.",
    backgroundColor: "#6DD6DA",
  },
  matthew: {
    name: "Matthew Siu",
    image: "matthew.jpeg",
    twitter: "MatthewWSiu",
    github: "Siunami",
    curius: "matthew-siu",
    description:
      "Matthew makes creative tools for collaboration and draws maps all day. He is trying to design serendipity and enjoys imagining the future of spaces we inhabit and the tools we use.",
  },
  noah: {
    name: "Noah Trenaman",
    image: "noah.jpg",
    twitter: "noahtren",
    github: "noahtren",
    website: "noahtren.com/",
    curius: "noah-trenaman",
    description:
      "Noah is studying computer science at the University of Cincinnati and has worked played a bit with neural networks. His main interests are deep learning, HCI, and a bit of design.",
  },
  santi: {
    name: "Santi Aranguri",
    image: "santi.jpg",
    github: "Aranguri",
    description:
      "Santi can often be found running to a whiteboard so that he can draw mathematical objects. He is studying Math at Stanford and is an Argentinian IT genius as a teen. He also plays guitar and beats you at soccer. He will design AGI eventually.",
  },
  steve: {
    name: "Stephen Fay",
    image: "steve.jpeg",
    twitter: "dcxStep",
    github: "dcxst",
    website: "dcxst.github.io/",
    curius: "stephen-fay",
    description:
      "Steve is currently pursuing an undergraduate degree in Mathematics and Physics at McGill University. He enjoys reading, biking, walking, talking, sleeping, problem-solving, coding. He grew up in Brussels (Belgium) and was a member of the souts et guides pluralistes throughout childhood (and briefly a scout-leader) before moving to Canada. His favourite color is blue and his favourite quote is 'that that is is, for what is that but that and is but is.",
  },
  taylor: {
    name: "Taylor Rogalski",
    image: "taylor.png",
    twitter: "tayroga",
    website: "tay.ro/",
    curius: "taylor-rogalski",
    description:
      "Taylor Rogalski is a product designer and aspiring engineer exploring ideas in intelligence augmentation. He's worked with Roam Research, Slashtalk,Primer, Slapdash, and Pioneer. Previously, he led design at ClassDojo, built personalized learning software for Summit Public Schools, and helped people stalk their friends with Facebook Graph Search. He thinks the attention economy is harvesting human potential and filling our brains with sludge, and instead wishes his phone would manipulate him into achieving his goals. Twitter.",
  },
  tiago: {
    name: "Tiago Sada",
    image: "tiago.png",
    twitter: "tiagosada",
    website: "www.tiagosada.com/",
    description:
      "Tiago designs and builds stuff. Previously, he co-founded and led Flinto to make financial services accesible for everyone in Mexico. They went through Y Combinator in 2018, and were acquired by Grin in 2019 to combine their financial products with Grin's mobility ones into one superapp for Latin America. In recent years, he's fallen many times learning to ski, built world champion robots with friends, and eaten a shocking amount of Red Baron deep dish pizza (pepperoni, of course).",
  },
  vincent: {
    name: "Vincent Huang",
    image: "vincent.jpg",
    twitter: "vvhuang_",
    curius: "vincent-huang",
    description:
      "Vincent is a sophomore at MIT interested in exploring math, cs, biology, and snacks. In the past, Vincent worked on models for refugee crises, participated in math olympiads, and wrote software at Amazon. When tired, he likes watching movies, opening messenger rooms, and journaling.",
    github: "vincenthuang75025",
    website: "vvhuang.com/",
    backgroundColor: "#000",
  },
  william: {
    name: "William Bryk",
    website: "www.welcometothecosmos.com/",
    image: "william.jpeg",
    github: "willbryk720",
    description:
      "William spends his free time writing 10,000-word blogs and singing opera. He studied physics and CS at Harvard University and is in an open relationship. He is from New York but has decided to live in Hawaii for a few weeks. ",
  },
  nala: {
    name: "Nala",
    website: "blog.noahtren.com/note/0738d304/",
    image: "nala.jpg",
    github: "willbryk720",
    description:
      'Nala doesn\'t bark, but if she did she would probably say "woof, woof, woof woof"',
  },
};
